import Script from 'next/script'
import PropTypes from 'prop-types'


GoogleAnalytics.propTypes = {
  data: PropTypes.shape({
    code: PropTypes.string,
  }).isRequired,
}

export default function GoogleAnalytics({ data }) {
  if(!data.code) {
    return null
  }
  return (
    <Script id="google-analytics-script">
      {data.code}
    </Script>
  )
}
